import { bool, string } from 'prop-types'

import ProductSpecialLabel from 'views/components/molecules/ProductSpecialLabel'
import { PROMOTION_TYPES } from 'views/components/organisms/ProductLabels/consts'
import { getPromotionLabelText } from 'views/components/organisms/ProductLabels/utils'
import { PromotionProductTypeV2 } from 'views/utils/propTypes/api'

const hasPromotionalProducts = ({ promotion, promotionProduct }) =>
  promotion && promotionProduct

const showPromotionLabel = ({ offerTypeSae, promotion, promotionProduct }) =>
  (offerTypeSae && hasPromotionalProducts({ promotion, promotionProduct })) ||
  promotion === PROMOTION_TYPES.BUNDLE

const ProductLabelPromotion = ({
  dataClientsideHook,
  link,
  offerTypeSae,
  promotion,
  promotionProduct,
}) =>
  showPromotionLabel({ offerTypeSae, promotion, promotionProduct }) ? (
    <li className="u-vertical-align--top u-margin-small--bottom u-margin-small--right o-ProductLabels__ProductLabelContainer o-ProductLabel__promotion">
      <ProductSpecialLabel
        text={getPromotionLabelText(promotion, promotionProduct)}
        promotion={promotion}
        link={link}
        dataClientsideHook={dataClientsideHook}
      />
    </li>
  ) : null

ProductLabelPromotion.propTypes = {
  dataClientsideHook: string,
  link: string,
  promotion: string,
  promotionProduct: PromotionProductTypeV2,
  offerTypeSae: bool,
}

ProductLabelPromotion.defaultProps = {
  dataClientsideHook: 'anchorLink',
  link: '#pflichtangabe',
  offerTypeSae: true,
  promotion: null,
  promotionProduct: null,
}

export default ProductLabelPromotion
